// https://github.com/LekoArts/gatsby-themes/blob/master/themes/gatsby-theme-minimal-blog/src/utils/replaceSlashes.ts

function replaceSlashes(input) {
  return input.replace(/\/\/+/g, `/`)
}

export default replaceSlashes
